import { UploadImage } from 'components'
import { Table } from '@sar/component'

import { Row, App } from 'antd'
import { ProForm, ProFormText, ProFormList, ProFormDependency, ProFormSelect, ProFormTreeSelect, ProFormDigit, ProFormDatePicker, ProFormDateTimePicker, ProFormTextArea, ProFormSwitch } from '@ant-design/pro-components'

async function fetchData (params, store) {
  let link = (
    params.selected == 'customer'
      ? '/customers/potential'
      : '/customers/dealer'
  )

  const result = await store.externals.api.get(link, {
    params: Object.assign(params, {
      page: params.current,
      size: params.pageSize,
    })
  })

  return {
    success: true,
    data: result.data,
    total: result.totals,
  }
}

function Update ({ store, navigator, params }) {
  const customerStage = React.useMemo(() => {
    return store.config.getConstantPairs(`CustomerStage`)
  }, [])

  return <div className='m-4 p-4 bg-white'>
    <ProForm
      grid={true}
      rowProps={{ gutter: 16 }}
      layout='vertical'
      className='max-w-[900px]'
      submitter={store.identity.hasPermission('/customer/list:update')}
      readonly={!store.identity.hasPermission('/customer/list:update')}
      request={() => store.externals.api.get(`/customers/${params.id}`)}
      onFinish={data => store.externals.api.put(`/customers/${params.id}`, data).then(() => navigator.back())}
    >
      <ProFormTreeSelect
        name='sourceId'
        label='客户信息来源'
        colProps={{ xs: 12 }}
        rules={[ { required: true, message: '请输入客户信息来源' } ]}
        request={() => store.externals.api.get(`/constant/source`)}
        fieldProps={{ fieldNames: { value: 'id', label: 'source' } }}
      />

      <ProFormText
        name='projectName'
        label='项目名称'
        colProps={{ xs: 12 }}
      />

      <ProFormText
        name='name'
        label='姓名'
        colProps={{ xs: 12 }}
        rules={[ { required: true, message: '请输入姓名' } ]}
      />

      <ProFormDependency name={[ 'stage' ]}>
        {({ stage }) => {
          return <ProFormText
            name='contactNumber'
            label='联系方式'
            colProps={{ xs: 12 }}
            rules={[ { required: stage == 2, message: '请输入联系方式' }, { pattern: /^1\d{10}$/, message: '请输入正确的电话号码' } ]}
          />
        }}
      </ProFormDependency>

      <ProFormText
        name='wechat'
        label='微信号'
        colProps={{ xs: 12 }}
      />

      <ProFormSelect
        showSearch
        name='assignedEmployeeId'
        label='跟踪人员'
        colProps={{ xs: 12 }}
        request={() => store.externals.api.get(`/emp/all`)}
        debounceTime={3000}
        fieldProps={{ optionFilterProp: 'nickname', fieldNames: { label: 'nickname', value: 'id' } }}
      />

      <ProFormDateTimePicker
        name='communicationTime'
        label='签单时间'
        width='lg'
        fieldProps={{ width: '100%' }}
        colProps={{ xs: 12 }}
      />

      <ProFormText
        name='address'
        label='地址'
        colProps={{ xs: 12 }}
      />

      <ProFormText
        name='inquiry'
        label='咨询内容'
        colProps={{ xs: 12 }}
      />

      <ProFormTextArea
        name='remark'
        label='备注'
        colProps={{ xs: 24 }}
        fieldProps={{ rows: 4 }}
      />

      <ProFormList
        name='trackList'
        label='跟踪反馈表'
        creatorRecord={() => ({ trackTime: moment().format('YYYY-MM-DD') })}
        itemRender={(dom, meta) => {
          return <div className='flex items-end'>
            <div className='flex-auto'>
              {dom.listDom}
            </div>

            <div className='flex-none w-64'>
              {meta.record?.id ? null : dom.action}
            </div>
          </div>
        }}
      >
        {(_, __, ref) => {
          return <Row gutter={16} className='px-4'>
            <ProFormText
              readonly
              name='trackTime'
              label='跟踪时间'
              colProps={{ xs: 8 }}
            />

            <ProFormText
              readonly={ref.getCurrentRowData().id != null}
              name='feedback'
              label='反馈'
              colProps={{ xs: 16 }}
            />
          </Row>
        }}
      </ProFormList>

      <ProFormSelect
        name='stage'
        label='客户进度'
        colProps={{ xs: 12 }}
        valueEnum={store.config.getConstantEnums(`CustomerStage`)}
      />

      <ProFormDatePicker
        name='reminderTime'
        label='下次跟单时间'
        width='lg'
        colProps={{ xs: 12 }}
      />

      <ProFormDependency name={[ 'stage' ]}>
        {({ stage }) => {
          if (stage != customerStage.close) {
            return null
          }

          else {
            return <ProFormTextArea
              name='noDealReason'
              label='不成交原因'
              fieldProps={{ rows: 4 }}
              rules={[ { required: true, message: '请输入不成交原因' } ]}
            />
          }
        }}
      </ProFormDependency>
    </ProForm>
  </div>
}

function Order ({ store, navigator, params }) {
  const columns = [
    {
      title: '客户姓名',
      dataIndex: 'customerName',
    },
    {
      title: '地址',
      dataIndex: 'customerAddress',
    },
    {
      title: '订单',
      dataIndex: 'type',
      valueType: 'select',
      valueEnum: store.config.getConstantEnums(`OrderType`),
    },
    {
      title: '订单状态',
      dataIndex: 'status',
      valueType: 'select',
      valueEnum: store.config.getConstantEnums(`OrderStatus`),
    },
    {
      title: '设计状态',
      dataIndex: 'designerStatus',
      valueType: 'select',
      valueEnum: { yes: '已设计', no: '未设计' },
    },
    {
      title: '报价状态',
      dataIndex: 'quoteStatus',
      valueType: 'select',
      valueEnum: { yes: '已报价', no: '未报价' },
    }
  ]

  async function fetchData (data) {
    const result = await store.externals.api.get(`/customers/order/${params.id}`, {
      params: {
        page: data.current,
        size: data.pageSize,
      }
    })

    return {
      success: true,
      data: result.data,
      total: result.totals,
    }
  }

  const rowActions = [
    {
      danger: true,
      name: '删除',
      confirmType: 'modal',
      confirmMessage: '您确定删除这个订单吗？',
      visible: () => store.identity.hasPermission('/customer/list/order:delete'),
      onConfirm: (data, handles) => store.externals.api.delete(`/orders/${data.id}`).then(() => handles.current.reload()),
    },
  ]

  return <div className='p-4'>
    <Table
      title='客户订单列表'
      columns={columns}
      request={fetchData}
      rowActions={rowActions}
    />
  </div>
}

function Subscribe ({ app, store, params, navigator }) {
  const { modal } = App.useApp()

  const getFormData = React.useCallback(data => {
    return Object.assign({}, data, {
      customerId: data.id,
      customerName: data.name,
      customerPhone: data.contactNumber,
      customerAddress: data.address ?? null,
      saleId: data.assignedEmployeeId ?? null,
      isDesigner: data.isDesigner ? 'yes' : 'no'
    })
  }, [])

  return <div className='m-4 p-4 bg-white'>
    <ProForm
      key={params.id}
      grid={true}
      rowProps={{ gutter: 16 }}
      layout='vertical'
      className='max-w-[900px]'
      initialValues={{ isDesigner: true }}
      request={() => store.externals.api.get(`/customers/${params.id}`)}
      onFinish={data => new Promise((resolve, reject) => {
        store.externals.api.post(`/orders/check`, R.omit([ 'id' ], getFormData(data))).then(res => {
          if (res) {
            modal.confirm({
              title: '温馨提示',
              content: '检测到已有相同姓名、电话、地址的订单，您确定要继续提交吗？',
              centered: true,
              maskClosable: false,
              onCancel: () => reject(),
              onOk: () => store.externals.api.post(`/orders`, R.omit([ 'id' ], getFormData(data))).then(() => resolve()).then(() => navigator.back()),
            })
          }

          else {
            modal.confirm({
              title: '温馨提示',
              content: '您确定要提交当前订单吗？',
              centered: true,
              maskClosable: false,
              onCancel: () => reject(),
              onOk: () => store.externals.api.post(`/orders`, R.omit([ 'id' ], getFormData(data))).then(() => resolve()).then(() => navigator.back()),
            })
          }
        })
      })}
    >
      <ProFormText
        hidden
        name='id'
      />

      <ProFormTreeSelect
        name='sourceId'
        label='客户信息来源'
        colProps={{ xs: 12 }}
        rules={[ { required: true, message: '请输入客户信息来源' } ]}
        request={() => store.externals.api.get(`/constant/source`)}
        fieldProps={{ fieldNames: { value: 'id', label: 'source' } }}
      />

      <ProFormDigit
        name='depositAmount'
        label='实收定金金额'
        min={0}
        colProps={{ xs: 12 }}
        fieldProps={{ precision: 2 }}
      />

      <ProFormText
        name='name'
        label='姓名'
        colProps={{ xs: 12 }}
        rules={[ { required: true, message: '请输入姓名' } ]}
      />

      <ProFormText
        name='contactNumber'
        label='联系方式'
        colProps={{ xs: 12 }}
        rules={[ { required: true, message: '请输入联系方式' }, { pattern: /^1\d{10}$/, message: '请输入正确的电话号码' } ]}
      />

      <ProFormSelect
        showSearch
        name='assignedEmployeeId'
        label='跟踪人员'
        colProps={{ xs: 12 }}
        request={() => store.externals.api.get(`/emp/all`)}
        debounceTime={3000}
        rules={[ { required: true, message: '请选择跟踪人员' } ]}
        fieldProps={{ optionFilterProp: 'nickname', fieldNames: { label: 'nickname', value: 'id' } }}
      />

      <ProFormDateTimePicker
        readonly
        name='communicationTime'
        label='签单时间'
        width='lg'
        fieldProps={{ width: '100%' }}
        colProps={{ xs: 12 }}
      />

      <ProFormText
        name='address'
        label='地址'
        colProps={{ xs: 12 }}
        rules={[ { required: true, message: '请输入地址' } ]}
      />

      <ProFormText
        readonly
        name='inquiry'
        label='咨询内容'
        colProps={{ xs: 12 }}
      />

      <ProFormTextArea
        readonly
        name='remark'
        label='备注'
        colProps={{ xs: 24 }}
        fieldProps={{ rows: 4 }}
      />

      <ProFormSelect
        name='type'
        label='订单类型'
        colProps={{ xs: 12 }}
        rules={[ { required: true, message: '请输入订单类型' } ]}
        valueEnum={store.config.getConstantEnums(`OrderType`)}
      />

      <ProFormSwitch
        name='isDesigner'
        colProps={{ xs: 12 }}
        label='是否需要设计'
        rules={[ { required: true, message: '请选择订单是否需要设计' } ]}
      />
    </ProForm>
  </div>
}

function List ({ store, navigator }) {
  const [ selected, dispatch ] = React.useState('customer')

  const columns = [
    {
      title: '客户姓名',
      dataIndex: 'name',
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ placeholder: '客户姓名' }),
    },
    {
      title: '联系电话',
      dataIndex: 'contactNumber',
      render: _ => _.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2'),
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ placeholder: '联系电话' }),
    },
    {
      title: '地址',
      dataIndex: 'address',
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ placeholder: '地址' }),
    },
    {
      title: '来源',
      dataIndex: 'sourceId',
      valueType: 'treeSelect',
      hideInTable: true,
      request: () => store.externals.api.get(`/constant/source`),
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ fieldNames: { value: 'id', label: 'source' }, placeholder: '来源' }),
    },
    {
      title: '来源',
      dataIndex: 'source',
    },
    {
      title: '跟踪阶段',
      dataIndex: 'stage',
      valueType: 'select',
      valueEnum: store.config.getConstantEnums(`CustomerStage`),
    },
    {
      title: '咨询内容',
      dataIndex: 'inquiry',
    },
    {
      title: '问题反馈结果',
      dataIndex: 'communicationResult',
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      valueType: 'datetime',
    },
  ]

  const rowActions = [
    {
      name: '查看',
      visible: () => store.identity.hasPermission('/customer/list/order'),
      onClick: (data) => navigator.to(`/customer/list/order/${data.id}`, `查看客户订单（${data.name}）`),
    },
    {
      name: '修改',
      visible: () => store.identity.hasPermission('/customer/list:update'),
      onClick: (data) => navigator.to(`/customer/list/update/${data.id}`, `修改客户（${data.name}）`),
    },
    {
      name: (
        selected == 'customer'
          ? '转为经销商'
          : '转为客户'
      ),
      confirmMessage: (
        selected == 'customer'
          ? '您确定要转为经销商吗？'
          : '您确定要转为客户吗？'
      ),
      confirmType: 'modal',
      visible: () => store.identity.hasPermission('/customer/list:update'),
      onConfirm: (data, handles) => (selected == 'customer' ? store.externals.api.put(`/customers/convertDealer/${data.id}`) : store.externals.api.put(`/customers/convert/${data.id}`)).then(() => handles.current.reload()),
    },
    {
      name: '下单',
      visible: () => store.identity.hasPermission('/customer/list:order'),
      onClick: (data) => navigator.to(`/customer/list/subscribe/${data.id}`, `客户下单（${data.name}）`),
    },
    {
      danger: true,
      name: '删除',
      confirmType: 'modal',
      confirmMessage: '您确定删除这个准客户吗？',
      visible: () => store.identity.hasPermission('/customer/list:delete'),
      onConfirm: (data, handles) => store.externals.api.delete(`/customers/${data.id}`).then(() => handles.current.reload()),
    },
  ]

  const cols = React.useMemo(() => {
    let showSearch = [
        'name'
      , 'contactNumber'
      , 'sourceId'
      , 'address'
    ]

    return columns.map(column => {
      if (showSearch.includes(column.dataIndex)) {
        return Object.assign(column)
      }

      else {
        return Object.assign(column, { hideInSearch: true })
      }
    })
  }, [])

  const onRow = React.useCallback(data => {
    if (data.reminderTime == null) {
      return null
    }

    else if (moment().isBefore(data.reminderTime, 'day')) {
      return null
    }

    else {
      return {
        className: 'text-red-600'
      }
    }
  }, [])

  return <div className='p-4'>
    <Table
      onRow={onRow}
      title='客户列表'
      columns={cols}
      rowActions={rowActions}
      params={{ selected }}
      request={params => fetchData(params, store)}
      scroll={{ }}
      search={{ labelWidth: 'auto', defaultCollapsed: true, span: Object.assign({}, store.config.responsive, { xxl: 4 }) }}
      toolbar={{
        multipleLine: true,
        tabs: {
          activeKey: selected,
          onChange: dispatch,
          items: [
            { key: 'customer', tab: '客户' },
            { key: 'dealer', tab: '经销商' },
          ],
        },
      }}
    />
  </div>
}

export default function (prefix, app) {
  return app
    .useRoute(`${prefix}/subscribe/:id`, Subscribe)
    .useRoute(`${prefix}/update/:id`, Update)
    .useRoute(`${prefix}/order/:id`, Order)
    .useRoute(`${prefix}/`, List)
}
